import React, { useEffect, useRef } from "react";
import { scrollToRef } from "../../../helpers/scroll_to_ref";
import HXAdvantage from "../HXAdvantage/HXAdvantage";
import HXFeedback from "../HXFeedback/HXFeedback";
import HXHeader from "../HXHeader/HXHeader";
import HXImageBanner from "../HXImageBanner/HXImageBanner";
import HXInfo from "../HXInfo/HXInfo";
import HXInsights from "../HXInsights/HXInsights";
import HXLandingCompanies from "../HXLandingCompanies/HXLandingCompanies";
import HXRegister from "../HXRegister/HXRegister";
import HXSteps from "../HXSteps/HXSteps";
import HXTagline from "../HXTagline/HXTagline";
import HXTextBanner from "../HXTextBanner/HXTextBanner";
import { Wrapper } from "./styles";

function XLandingPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  const packageRef = useRef(null);

  return (
    <>
      <Wrapper>
        <HXHeader onScrollToPackage={() => scrollToRef(packageRef, 80)} />
        <HXTagline />
        <HXLandingCompanies />
        <HXInfo onScrollToPackage={() => scrollToRef(packageRef, 80)} />
        <HXTextBanner onScrollToPackage={() => scrollToRef(packageRef, 80)} />
        <HXAdvantage />
        <HXImageBanner />
        <HXSteps />
        <HXFeedback />
        <div ref={packageRef}>
          <HXRegister />
        </div>
        <HXInsights />
      </Wrapper>
    </>
  );
}

export default XLandingPage;
